export default {
  branchOffices: (state) => state.branchOffices,
  selectedBranchOffice: (state) => state.selectedBranchOffice,
  loading: (state) => state.loading,
  branchOffice: (state) => (id) => {
    id = parseInt(id, 10)
    return state.branchOffices.find((branchOffice) => branchOffice.id === id)
  },
}
